export enum UserRole {
    NOT_LOGED_IN = 0,
    USER = 5,
    MEMBER = 4,
    SEMI_PRO = 3,
    ADMIN = 2,
    SUPER_ADMIN = 1,
}


// WEBPACK FOOTER //
// ./src/types/UserRole.tsx